/**
 * StatisticMenuCategory
 * --
 */
import React from 'react';
import { Descriptions, Table, Button, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Content, Title, Row, Col } from 'components';
import moment from 'moment';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import { downloadXlsx } from 'utils/XlsxDownloader';

/* 

카테고리별 매출 : 사용중인 필드
  menu: 메뉴명
  totalAmount: 합계금액
  netSales: 순매출
  paymentsCount: 판매수량
  couponAppliedCount: 쿠폰사용수량
  discountAmount: 쿠폰사용

   {
    "menu_name": "콜드브루 라뗴",
    "menu_id": 1,
    "menu_count": 11,
    "total_amount": 68200,
    "product_category_id": 1,
    "product_category_name": "Special COFFEE"
}
    
*/
const SEARCH_KEYWORD = {
  product_category_name: null,
};
/**----------------------------------------
 * [Component] 카테고리별 매출
 * ----------------------------------------
 */
const StatisticMenuCategory = ({
  // shopList, // 업체목록
  // currentShop, // 선택된 업체 키
  data, // 차트 데이터
  startDate,
  endDate,
  dateRange,
  // onSelect,
  finalDiscount,
  finalUsePoint,
  menuCoupon,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [searchValue, setSearchValue] = React.useState(SEARCH_KEYWORD);
  /* ===== VARIABLE ===== */
  // const currentShopInfo = shopList.filter(({ key }) => key === currentShop)[0];

  const expandableColumns = (product_category_id) => [
    {
      title: '메뉴명',
      dataIndex: 'menu_name',
      width: 330,
      // fixed: 'left',
      filterDropdown: ({ selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={searchValue[product_category_id]?.menu_name}
            onChange={(e) =>
              handleChange('menu_name', e.target.value, product_category_id)
            }
            onPressEnter={() => confirm()}
            placeholder={`메뉴명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                handleChange('menu_name', null, product_category_id);
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '총매출',
      dataIndex: 'totalAmount',
      width: 160,
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(record.totalAmount))}
        </div>
      ),
      sorter: (a, b) => Number(a.totalAmount) - Number(b.totalAmount),
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          순매출
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (총매출-할인-포인트)
          </span>
        </span>
      ),
      dataIndex: 'salesAmount',
      width: 160,
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(
            Number(record.totalAmount) - Number(record.discountAmount)
          )}
        </div>
      ),
      sorter: (a, b) => {
        const aa = Number(a.totalAmount) - Number(a.discountAmount);
        const bb = Number(b.totalAmount) - Number(b.discountAmount);
        return aa - bb;
      },
    },
    {
      title: <span style={{ lineHeight: 0.5 }}>단가</span>,
      dataIndex: 'menu_price',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.menu_price - b.menu_price,
    },
    {
      title: <span style={{ lineHeight: 0.5 }}>메뉴판매량</span>,
      dataIndex: 'menu_count',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.menu_count - b.menu_count,
    },
    {
      title: '할인',
      dataIndex: 'discountAmount',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.discountAmount - b.discountAmount,
    },
    {
      title: '쿠폰',
      dataIndex: 'coupon_count',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.coupon_count - b.coupon_count,
    },
  ];

  /* ===== FUNCTION ===== */
  /**
   *
   * --
   */
  const handleCalculate = (d, key) => {
    if (!d || d.length < 1) {
      return 0;
    }
    return d.reduce((acc, cur) => acc + Number(cur[key] ?? 0), 0);
  };
  /**
   * 엑셀 다운로드
   * --
   */
  const handleDownloadExel = () => {
    try {
      const col = [
        {
          title: '카테고리명',
          dataIndex: 'product_category_name',
        },
        ...expandableColumns(),
      ];
      // downloadXlsx
      const xlsxData = newDataWithPosDiscount
        ?.map((item) => {
          return item?.menus?.map((menu) => {
            return {
              product_category_name: item?.product_category_name,
              salesAmount:
                Number(menu.totalAmount) - Number(menu.discountAmount),
              ...menu,
            };
          });
        })
        ?.flat();

      const pos = newDataWithPosDiscount?.find(
        (item) => item?.key === 'pos-discount'
      );
      console.log('newDataWithPosDiscount =====>', newDataWithPosDiscount);
      console.log('xlsxData =====>', xlsxData);
      console.log('pos =====>', pos);

      downloadXlsx({
        columns: col?.map((column) => {
          if (typeof column?.title !== 'string') {
            const titleChildren = column?.title?.props?.children;
            if (Array.isArray(titleChildren)) {
              column.title = titleChildren
                .map((child) =>
                  typeof child === 'string'
                    ? child
                    : child?.props?.children ?? ''
                )
                .join('');
            } else if (typeof titleChildren === 'string') {
              column.title = titleChildren;
            } else if (React.isValidElement(titleChildren)) {
              column.title = titleChildren.props?.children ?? '';
            } else {
              column.title = '';
            }
          }
          return column;
        }),
        rows: [
          ...xlsxData,
          ...(!pos
            ? []
            : [
                {
                  product_category_name: pos.product_category_name,
                  salesAmount: pos.totalAmount - pos.discountAmount,
                  coupon_count: 0,
                  discountAmount: pos.discountAmount,
                  key: xlsxData.length,
                  menu_count: 0,
                  menu_id: 0,
                  menu_name: pos.product_category_name,
                  totalAmount: pos.totalAmount,
                },
              ]),
        ],
        fileName: '카테고리별_매출',
      });
    } catch (e) {
      console.log(e);
      MessageAlert.error(e.message);
    }
  };

  /**
   * 데이터 바인팅
   * --
   * @param {string} t
   * @param {string | number} v
   */
  const handleChange = (t, v, product_category_id) => {
    setSearchValue((prev) => {
      if (product_category_id) {
        return {
          ...prev,
          [product_category_id]: {
            ...prev[product_category_id],
            [t]: v,
          },
        };
      } else {
        return {
          ...prev,
          [t]: v,
        };
      }
    });
  };
  /* ===== RENDER ===== */

  const columns = [
    {
      title: '카테고리명',
      dataIndex: 'product_category_name',
      width: 330,
      filterDropdown: ({ selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            value={searchValue?.product_category_name}
            onChange={(e) =>
              handleChange('product_category_name', e.target.value)
            }
            onPressEnter={() => confirm()}
            placeholder={`메뉴명 검색`}
          />
          <Space style={{ marginTop: 8 }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              검색
            </Button>
            <Button
              onClick={() => {
                handleChange('product_category_name', null);
                clearFilters();
              }}
              size="small"
              style={{ width: 90 }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '총매출',
      dataIndex: 'totalAmount',
      width: 160,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.totalAmount - b.totalAmount,
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          순매출
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (총매출-할인)
          </span>
        </span>
      ),
      dataIndex: 'salesAmount',
      width: 160,
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(
            Number(record.totalAmount) - Number(record.discountAmount)
          )}
        </div>
      ),
      sorter: (a, b) => {
        const aa = Number(a.totalAmount) - Number(a.discountAmount);
        const bb = Number(b.totalAmount) - Number(b.discountAmount);
        return aa - bb;
      },
    },
    {
      title: <span style={{ lineHeight: 0.5 }}>카테고리판매량</span>,
      dataIndex: 'total_count',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.total_count - b.total_count,
    },
    {
      title: '할인',
      dataIndex: 'discountAmount',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.discountAmount - b.discountAmount,
    },
    {
      title: '쿠폰',
      dataIndex: 'coupon_count',
      width: 150,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(v))}
        </div>
      ),
      sorter: (a, b) => a.coupon_count - b.coupon_count,
    },
  ];

  /**
   * 데이터 정제
   * --
   */
  const newData =
    data &&
    menuCoupon &&
    data
      ?.map((item) => {
        const ff = menuCoupon.find((m) => m.menu_name === item.menu_name);
        return {
          ...item,
          coupon_count: Number(ff?.coupon_count) ?? 0,
          discountAmount: Number(ff?.discountAmount) ?? 0,
        };
      })
      ?.reduce((acc, menu, index) => {
        const {
          product_category_id,
          product_category_name,
          menu_id,
          menu_name,
          menu_count,
          totalAmount,
          coupon_count,
          discountAmount,
          menu_price,
        } = menu;

        // 기존에 같은 product_category_id가 있는지 찾기
        const existingCategory = acc.find(
          (category) => category.product_category_id === product_category_id
        );

        if (existingCategory) {
          // 같은 카테고리가 있으면, 메뉴만 추가하고 합계 업데이트
          existingCategory.menus.push({
            key: index,
            menu_id,
            menu_name,
            menu_count,
            totalAmount,
            coupon_count,
            discountAmount,
            menu_price,
          });

          existingCategory.total_count += menu_count;
          existingCategory.coupon_count += coupon_count;
          existingCategory.discountAmount += discountAmount;
          existingCategory.totalAmount += totalAmount;
        } else {
          // 새로운 카테고리 추가
          acc.push({
            key: product_category_id,
            product_category_id,
            product_category_name,
            total_count: menu_count,
            coupon_count,
            discountAmount,
            totalAmount,
            menus: [
              {
                key: index,
                menu_id,
                menu_name,
                menu_count,
                totalAmount,
                coupon_count,
                discountAmount,
                menu_price,
              },
            ],
          });
        }

        return acc;
      }, []);
  // 기간내 할인금액 => order 테이블의 final_discount
  const finalDiscount2 = Math.abs(Number(finalDiscount));
  const finalUsePoint2 = Math.abs(Number(finalUsePoint));
  const couponDiscountAmount = handleCalculate(newData, 'discountAmount');
  let diffDiscount = finalDiscount2 - couponDiscountAmount;
  /**
   * 포스 데이터 추가
   * --
   */
  const newDataWithPosDiscount = newData
    ? [
        ...newData,
        {
          key: 'pos-discount',
          product_category_name: '포스 할인금액',
          discountAmount: diffDiscount,
          coupon_count: 0,
          totalAmount: 0,
          total_count: 0,
          menus: [],
        },
      ]
    : [];
  /* ===== HOOKS ===== */
  /**
   * 검색 필터
   * --
   */
  const newDataList = React.useMemo(() => {
    let arr = newDataWithPosDiscount; // 얕은 복사로 참조 분리
    const { product_category_name, ...rest } = searchValue;

    if (product_category_name) {
      arr = arr.filter((item) =>
        item.product_category_name.includes(product_category_name)
      );
    }
    const entries = Object.entries(rest);
    if (entries.length) {
      arr = arr.filter((item) => {
        const condition = rest?.[item.product_category_id];
        if (!condition) return true; // 필터 없으면 통과

        const { menu_name } = condition;

        if (menu_name) {
          item.menus = item?.menus?.filter((menu) =>
            menu.menu_name?.includes(menu_name)
          );
        }

        return true;
      });
    }
    return arr;
  }, [searchValue, newDataWithPosDiscount]);
  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Row>
          {/* === 상단 > 타이틀 === */}
          <Col x={12} style={{ display: 'flex', gap: 10 }}>
            <Title style={{ marginBottom: 7.5 }}>
              카테고리별 리포트
              {/* {/* {currentShopInfo && `(${currentShopInfo.shop_information_name})`} */}
            </Title>
            <Button onClick={() => handleDownloadExel()}>
              엑셀로 다운로드
            </Button>
          </Col>
          <Col x={12} style={{ textAlign: 'right' }}>
            <Title
              level={5}
              align="right"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 7.5,
              }}
            >
              <small>조회기간:</small>&nbsp;&nbsp;
              {!dateRange.startDate || !dateRange.endDate ? (
                <>
                  {moment(startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(endDate).format('YYYY.MM.DD(ddd)')}
                </>
              ) : (
                <>
                  {moment(dateRange.startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(dateRange.endDate).format('YYYY.MM.DD(ddd)')}
                </>
              )}
            </Title>
          </Col>
        </Row>
        <div style={{ background: '#fff' }}>
          {newData && (
            <Descriptions
              // title="User Info"
              className="boxShadow"
              size="small"
              layout="vertical"
              column={15}
              bordered
              style={{ width: '100%' }}
              // labelStyle={{ width: 135 }}
              contentStyle={{ textAlign: 'right' }}
              items={[
                {
                  key: 'date',
                  label: '',
                  contentStyle: { textAlign: 'center' },
                  style: { width: 330 },
                  children: <p>합계</p>,
                },
                {
                  key: 'totalAmount',
                  label: <span style={{ lineHeight: 0.5 }}>총매출</span>,
                  style: { width: 160 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newData, 'totalAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'netSales',
                  label: (
                    <span style={{ lineHeight: 0.5 }}>
                      순매출
                      <br />
                      <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                        (총매출-할인-포인트)
                      </span>
                    </span>
                  ),
                  style: { width: 160 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newData, 'totalAmount') -
                          finalDiscount2 -
                          finalUsePoint2
                      )}
                    </p>
                  ),
                },
                {
                  key: 'total_count',
                  label: '카테고리판매량',
                  style: { width: 150 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newData, 'total_count')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'discountAmount',
                  label: '할인금액',
                  style: { width: 150 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        Number(finalDiscount)
                        // handleCalculate(newData, 'discountAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'finalUsePoint2',
                  label: '사용포인트',
                  style: { width: 150 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        finalUsePoint2
                        // handleCalculate(newData, 'discountAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'coupon_count',
                  // label: '쿠폰주문',
                  label: '사용쿠폰',
                  style: { width: 150 },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(newData, 'coupon_count')
                      )}
                    </p>
                  ),
                },
                // {
                //   key: 'counponDiscount',
                //   label: '쿠폰할인',
                //   style: { width: 100 },
                //   children: (
                //     <p>
                //       {stringToMoneyFormat(
                //         handleCalculate(newData, 'counponDiscount')
                //       )}
                //     </p>
                //   ),
                // },

                // REVIEW - 데이터가 집계되지 않아 숨김처리함.
                // {
                //   key: 'refundAmount',
                //   label: '환불금액',
                //   style: { width: 150 },
                //   children: (
                //     <p>
                //       {stringToMoneyFormat(
                //         handleCalculate(newData, 'refundAmount')
                //       )}
                //     </p>
                //   ),
                // },

                // {
                //   key: 'refundCount',
                //   label: '환불건수',
                //   style: { width: 150 },
                //   children: (
                //     <p>
                //       {stringToMoneyFormat(
                //         handleCalculate(newData, 'refundCount')
                //       )}
                //     </p>
                //   ),
                // },
              ]}
            />
          )}
        </div>
        <br />

        <div
          style={{
            overflow: 'auto',
            width: '100%',
            height: '100%',
            background: '#fff',
          }}
        >
          {/* {(() => {
            console.log('newData: ', newData);
          })()} */}
          <Table
            className="boxShadow"
            bordered
            size="small"
            dataSource={newDataList}
            columns={columns}
            onRow={(record) => {
              return {
                style: {
                  borderBottom: '1px solid #000', // 행의 아래쪽에만 테두리 추가
                  transition: 'none', // 호버 효과 없애기
                  fontWeight: 'bold', // 텍스트 굵게
                },
              };
            }}
            expandable={{
              expandedRowRender: (rw) => {
                const [menu] = newDataList?.filter(
                  (item) => item.product_category_id === rw.product_category_id
                );
                return (
                  <Table
                    columns={expandableColumns(rw?.product_category_id)}
                    // dataSource={result}
                    dataSource={menu?.menus}
                    pagination={false}
                  />
                );
              },
              // defaultExpandedRowKeys: ['1', '2', '3'],
              // expandedRowKeys: newDataList?.menus?.map((item) => item?.key),
            }}
            scroll={{
              x: 'max-content',
            }}
            style={{ minHeight: 580, width: 1400 }}
            // onRow={(record) => {
            //   return {
            //     onClick: () =>
            //       onSelect({ ...record, STATISTIC_TYPE: 'OPTION' }), // 행 클릭 시 이벤트 처리
            //     // onClick: () => console.log('record : ', record), // 행 클릭 시 이벤트 처리
            //   };
            // }}
          />
        </div>
      </Content>
    </>
  );
};

export default StatisticMenuCategory;
